import { Module } from 'data/terra/Module';
import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { ModuleSelectorState } from '../reducer';

export const FETCH_MODULES = 'FETCH_MODULES';

export interface FetchModulesAction {
  type: typeof FETCH_MODULES;
  modules: Module[];
}

export const fetchModules = (
  productId: string
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  const result = await Terra.module.fetchModules(productId);
  if (result.isSuccess()) {
    dispatch({
      type: FETCH_MODULES,
      modules: result.get()!.data,
    } as FetchModulesAction);
  }

  return result;
};

export const fetchModulesDelegate: DelegateMapEntry<
  FetchModulesAction,
  ModuleSelectorState
> = {
  [FETCH_MODULES]: (
    state: ModuleSelectorState,
    action: FetchModulesAction
  ): ModuleSelectorState => {
    return {
      ...state,
      modules: action.modules,
    };
  },
};
